export const findValueAndLabel = (
	id,
	array,
	property = "value",
	strictCompare = false
) => {
	const found = array.find((item) =>
		// eslint-disable-next-line
		strictCompare ? item[property] === id : item[property] == id
	);
	return found?.value ? { value: found?.value, label: found?.label } : null;
};


export const normalizeValueLabel = (input, array) => {
	if (
		!input ||
		typeof input !== "object" ||
		input.value === 0 ||
		(input.label == null && input.value == null)
	) {
		return null;
	}

	if (input.label != null) {
		return { label: input.label, value: input.value };
	}

	return findValueAndLabel(input.value, array);
};